import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Image, Collapse, Card, ListGroup } from "react-bootstrap";
import axios from "axios";

const colors = {
  primary: "#062d59",
  danger: "#e3080c",
  light: "#fff",
};

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [selectedSeller, setSelectedSeller] = useState(null);
const [showSellerModal, setShowSellerModal] = useState(false);

const handleSellerClick = (prod) => {
  setSelectedSeller(prod);
  setShowSellerModal(true);
};


  const fetchProducts = async () => {
    try {
      const res = await axios.get("https://vyaparapi.emedha.in/api/seller/api/products");
      setProducts(res.data);
    } catch (err) {
      alert("Failed to load products");
    }
  };

  const handleApprove = async (id) => {
    try {
      await axios.post(`https://vyaparapi.emedha.in/api/seller/api/products/${id}/approve`);
      fetchProducts();
    } catch {
      alert("Failed to approve");
    }
  };

const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this product?");
  if (!confirmDelete) return;

  try {
    await axios.delete(`https://vyaparapi.emedha.in/api/seller/api/products/${id}`);
    fetchProducts();
  } catch {
    alert("Failed to delete");
  }
};


  useEffect(() => {
    fetchProducts();
  }, []);

  const toggleSpecs = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div style={{ background: colors.primary, minHeight: "100vh", padding: "20px"  ,  borderRadius: '8px'}}   className="container mt-4">
      <h3 style={{ color: colors.light }}>Admin Products</h3>
      <Table striped bordered hover variant="light" className="mt-3" responsive>
        <thead style={{ background: colors.danger }}>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Seller</th>
            <th>Name</th>
            <th>Category</th>
            <th>Price</th>
            <th>Validity</th>
            <th>Warranty</th>
             <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((prod, idx) => (
            <React.Fragment key={prod.id}>
              <tr>
                <td>{idx + 1}</td>
                <td>
                  <Image
                    src={prod.image}
                    thumbnail
                    width={60}
                    onClick={() => {
                      setSelectedProduct(prod);
                      setShowModal(true);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </td>
             <td
  onClick={() => handleSellerClick(prod)}
  style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
>
  {prod.user_name}
</td>

                <td>{prod.name}</td>
        
                <td>{prod.category}</td>
                <td>₹{prod.price}</td>
                <td>{prod.validity}</td>
                <td>{prod.warranty}</td>
                <td>
          <span className={`badge bg-${prod.status === 'approved' ? 'success' : 'warning'}`}>
            {prod.status === 'approved' ? 'Approved' : 'Pending'}
          </span>
        </td>
                <td>
                  <Button
  variant={prod.status === 'approved' ? "secondary" : "success"}
  size="sm"
  onClick={() => handleApprove(prod.id)}
  className="me-2"
  disabled={prod.status === 'approved'}
>
  {prod.status === 'approved' ? "Approved" : "Approve"}
</Button>

                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(prod.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>

            </React.Fragment>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg"   style={{ zIndex: 9999 }}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProduct?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={selectedProduct?.image} fluid />
          <p className="mt-3"><strong>Category:</strong> {selectedProduct?.category}</p>
          <p><strong>Price:</strong> ₹{selectedProduct?.price}</p>
          <p><strong>Warranty:</strong> {selectedProduct?.warranty}</p>
          <p><strong>Validity:</strong> {selectedProduct?.validity}</p>
          <p><strong>Created At:</strong> {selectedProduct?.created_at}</p>
       <pre
  style={{
    whiteSpace: "pre-wrap",
    color: "#062d59",
    background: "#eee",
    padding: "10px",
    maxHeight: "200px", // Adjust height as needed
    overflow: "auto",
    borderRadius: "6px"
  }}
>
  {selectedProduct?.specifications}
</pre>

        </Modal.Body>
      </Modal>

      <Modal
  show={showSellerModal}
  onHide={() => setShowSellerModal(false)}
  centered
  size="md"
  style={{ zIndex: 9999 }}
>
  <Modal.Header closeButton style={{ backgroundColor: colors.primary, color: colors.light }}>
    <Modal.Title>Seller Details</Modal.Title>
  </Modal.Header>
<Modal.Body style={{ backgroundColor: "#f9f9f9" }}>
  <Card className="shadow-sm border-0">
    <Card.Body>
      <div className="text-center mb-4">
        <div
          style={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "#ddd",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 30,
            color: colors.primary,
            fontWeight: "bold",
          }}
        >
          {selectedSeller?.user_name?.charAt(0).toUpperCase()}
        </div>
        <h5 className="mt-3 mb-1" style={{ color: colors.primary }}>
          {selectedSeller?.user_name}
        </h5>
        <p className="text-muted" style={{ marginBottom: 0 }}>
          Seller Profile
        </p>
      </div>

      <ListGroup variant="flush" style={{ fontSize: "15px" }}>
        <ListGroup.Item>
          <strong>Email:</strong> <span className="text-muted">{selectedSeller?.email || "N/A"}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          <strong>Phone:</strong> <span className="text-muted">{selectedSeller?.mobile || "N/A"}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          <strong>Address (City):</strong> <span className="text-muted">{selectedSeller?.city || "N/A"}</span>
        </ListGroup.Item>
        <ListGroup.Item>
          <strong>GST Number:</strong> <span className="text-muted">{selectedSeller?.gst_number || "N/A"}</span>
        </ListGroup.Item>
<ListGroup.Item>
  <strong>KYC Status: </strong>
  <span>
    1)GST Verification:{" "}
    {selectedSeller?.gst_verify ? "✅ Verified" : "⚠️ Pending"}
    <br />
    <span style={{ paddingLeft: "80px" }}>
       2)Aadhar Verification:{" "}
      {selectedSeller?.aadhar_verify ? "✅ Verified" : "⚠️ Pending"}
    </span>
  </span>
</ListGroup.Item>



      </ListGroup>
    </Card.Body>
  </Card>
</Modal.Body>

</Modal>

    </div>
  );
}


// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   Button,
//   Modal,
//   Image,
//   Card,
//   ListGroup,
//   Pagination,
//   Form,
//   Row,
//   Col,
// } from "react-bootstrap";
// import axios from "axios";

// const colors = {
//   primary: "#062d59",
//   danger: "#e3080c",
//   light: "#fff",
// };

// export default function AdminProducts() {
//   const [products, setProducts] = useState([]);
//   const [expandedId, setExpandedId] = useState(null);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [selectedSeller, setSelectedSeller] = useState(null);
//   const [showSellerModal, setShowSellerModal] = useState(false);

//   // Pagination & Search
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;
//   const [searchTerm, setSearchTerm] = useState("");

//   const handleSellerClick = (prod) => {
//     setSelectedSeller(prod);
//     setShowSellerModal(true);
//   };

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(
//         "https://vyaparapi.emedha.in/api/seller/api/products"
//       );
//       setProducts(res.data);
//     } catch (err) {
//       alert("Failed to load products");
//     }
//   };

//   const handleApprove = async (id) => {
//     try {
//       await axios.post(
//         `https://vyaparapi.emedha.in/api/seller/api/products/${id}/approve`
//       );
//       fetchProducts();
//     } catch {
//       alert("Failed to approve");
//     }
//   };

//   const handleDelete = async (id) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this product?"
//     );
//     if (!confirmDelete) return;

//     try {
//       await axios.delete(`https://vyaparapi.emedha.in/api/seller/api/products/${id}`);
//       fetchProducts();
//     } catch {
//       alert("Failed to delete");
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const toggleSpecs = (id) => {
//     setExpandedId(expandedId === id ? null : id);
//   };

//   // Filter products based on search term (case insensitive)
//   const filteredProducts = products.filter((prod) =>
//     prod.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Pagination calculations
//   const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
//   const displayedProducts = filteredProducts.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // Generate pagination items
//   const paginationItems = [];
//   for (let page = 1; page <= totalPages; page++) {
//     paginationItems.push(
//       <Pagination.Item
//         key={page}
//         active={page === currentPage}
//         onClick={() => setCurrentPage(page)}
//       >
//         {page}
//       </Pagination.Item>
//     );
//   }

//   return (
//     <div
//       style={{
//         background: colors.primary,
//         minHeight: "100vh",
//         padding: "20px",
//         borderRadius: "8px",
//       }}
//       className="container mt-4"
//     >
//       <Row className="align-items-center mb-3">
//         <Col>
//           <h3 style={{ color: colors.light }}>Admin Products</h3>
//         </Col>
//         <Col xs="auto">
//           <Form.Control
//             type="search"
//             placeholder="Search products..."
//             value={searchTerm}
//             onChange={(e) => {
//               setSearchTerm(e.target.value);
//               setCurrentPage(1); // Reset to page 1 when search changes
//             }}
//           />
//         </Col>
//       </Row>

//       <Table striped bordered hover variant="light" className="mt-1" responsive>
//         <thead style={{ background: colors.danger }}>
//           <tr>
//             <th>#</th>
//             <th>Image</th>
//             <th>Seller</th>
//             <th>Name</th>
//             <th>Category</th>
//             <th>Price</th>
//             <th>Validity</th>
//             <th>Warranty</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {displayedProducts.map((prod, idx) => (
//             <React.Fragment key={prod.id}>
//               <tr>
//                 <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
//                 <td>
//                   <Image
//                     src={prod.image}
//                     thumbnail
//                     width={60}
//                     onClick={() => {
//                       setSelectedProduct(prod);
//                       setShowModal(true);
//                     }}
//                     style={{ cursor: "pointer" }}
//                   />
//                 </td>
//                 <td
//                   onClick={() => handleSellerClick(prod)}
//                   style={{
//                     cursor: "pointer",
//                     color: "#007bff",
//                     textDecoration: "underline",
//                   }}
//                 >
//                   {prod.user_name}
//                 </td>

//                 <td>{prod.name}</td>

//                 <td>{prod.category}</td>
//                 <td>₹{prod.price}</td>
//                 <td>{prod.validity}</td>
//                 <td>{prod.warranty}</td>
//                 <td>
//                   <span
//                     className={`badge bg-${
//                       prod.status === "approved" ? "success" : "warning"
//                     }`}
//                   >
//                     {prod.status === "approved" ? "Approved" : "Pending"}
//                   </span>
//                 </td>
//                 <td>
//                   <Button
//                     variant={prod.status === "approved" ? "secondary" : "success"}
//                     size="sm"
//                     onClick={() => handleApprove(prod.id)}
//                     className="me-2"
//                     disabled={prod.status === "approved"}
//                   >
//                     {prod.status === "approved" ? "Approved" : "Approve"}
//                   </Button>

//                   <Button
//                     variant="danger"
//                     size="sm"
//                     onClick={() => handleDelete(prod.id)}
//                   >
//                     Delete
//                   </Button>
//                 </td>
//               </tr>
//             </React.Fragment>
//           ))}
//           {displayedProducts.length === 0 && (
//             <tr>
//               <td colSpan="10" className="text-center text-muted">
//                 No products found.
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       {/* Pagination controls */}
//       {totalPages > 1 && (
//         <Pagination className="justify-content-center">{paginationItems}</Pagination>
//       )}

//       {/* Product details modal */}
//       <Modal
//         show={showModal}
//         onHide={() => setShowModal(false)}
//         centered
//         size="lg"
//         style={{ zIndex: 9999 }}
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{selectedProduct?.name}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Image src={selectedProduct?.image} fluid />
//           <p className="mt-3">
//             <strong>Category:</strong> {selectedProduct?.category}
//           </p>
//           <p>
//             <strong>Price:</strong> ₹{selectedProduct?.price}
//           </p>
//           <p>
//             <strong>Warranty:</strong> {selectedProduct?.warranty}
//           </p>
//           <p>
//             <strong>Validity:</strong> {selectedProduct?.validity}
//           </p>
//           <p>
//             <strong>Created At:</strong> {selectedProduct?.created_at}
//           </p>
//           <pre
//             style={{
//               whiteSpace: "pre-wrap",
//               color: "#062d59",
//               background: "#eee",
//               padding: "10px",
//               maxHeight: "200px", // Adjust height as needed
//               overflow: "auto",
//               borderRadius: "6px",
//             }}
//           >
//             {selectedProduct?.specifications}
//           </pre>
//         </Modal.Body>
//       </Modal>

//       {/* Seller details modal */}
//       <Modal
//         show={showSellerModal}
//         onHide={() => setShowSellerModal(false)}
//         centered
//         size="md"
//         style={{ zIndex: 9999 }}
//       >
//         <Modal.Header
//           closeButton
//           style={{ backgroundColor: colors.primary, color: colors.light }}
//         >
//           <Modal.Title>Seller Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ backgroundColor: "#f9f9f9" }}>
//           <Card className="shadow-sm border-0">
//             <Card.Body>
//               <div className="text-center mb-4">
//                 <div
//                   style={{
//                     width: 80,
//                     height: 80,
//                     borderRadius: "50%",
//                     backgroundColor: "#ddd",
//                     display: "inline-flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: 30,
//                     color: colors.primary,
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {selectedSeller?.user_name?.charAt(0).toUpperCase()}
//                 </div>
//                 <h5 className="mt-3 mb-0">{selectedSeller?.user_name}</h5>
//               </div>
//               <ListGroup variant="flush">
//                 <ListGroup.Item>
//                   <strong>Email:</strong> {selectedSeller?.email}
//                 </ListGroup.Item>
//                 <ListGroup.Item>
//                   <strong>Mobile:</strong> {selectedSeller?.mobile}
//                 </ListGroup.Item>
//                 <ListGroup.Item>
//                   <strong>Address:</strong> {selectedSeller?.user_address}
//                 </ListGroup.Item>
//               </ListGroup>
//             </Card.Body>
//           </Card>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }
